import { httpLogin } from "Utils/httpLogin";
import { STATUSES } from "Utils/constants";

// Send token via phone or emal
const mfaSendToken = async (mfaToken, request) => {

  let status = STATUSES.SUCCESS;

  // {
  //   userFactor: "SMS" or "EMAIL"
  // }
  let body = request;

  const url = "/auth/mfa/sendToken";
  const res = await httpLogin.post(url, body, {
    headers: {
      "Authorization": "Bearer " + mfaToken
    }
  }).then((res) => {
    
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};

// Verify token
const mfaVerifyToken = async (mfaToken, request) => {

  let status = STATUSES.SUCCESS;

  // {  
  //   mfaToken: "123456", 
  //   userFactor: "SMS" or "EMAIL"
  // }
  let body = request;

  const url = "/auth/mfa/verifyToken";
  const res = await httpLogin.post(url, body, {
    headers: {
      "Authorization": "Bearer " + mfaToken
    }
  }).then((res) => {
    
    return Promise.resolve({ status: status, data: res });
  }).catch(function (error) {
    status = STATUSES.ERROR;;
    return Promise.reject({ status: status, data: error });
  });

  return res;
};



export { mfaSendToken, mfaVerifyToken }

